import { useMemo } from 'react';

import usePublishedGuides from 'services/general/guidesList';

import { TextLink } from 'components';
import { Typography, TextColor } from '@repo/ui';

import { GuideCard } from './GuideCard';
import styles from './GuidesForYou.module.css';

export const GuidesForYou = () => {
  const { data: guides } = usePublishedGuides();
  const guidesToShow = useMemo(() => guides?.slice(0, 3), [guides]);

  if (!guidesToShow?.length) return <></>;
  return (
    <div className={styles.container}>
      <div className='flex align-items-center justify-content-between gap-1'>
        <Typography variant='heading-m'>Recent guides</Typography>
        <TextLink
          label='View all guides'
          iconNameRight='chevronForward'
          to='/guides'
          size='label'
          color={TextColor.PURPLE}
        />
      </div>
      <div className={styles.cardsContainer}>
        {guidesToShow.map(guide => (
          <GuideCard key={guide.id} guide={guide} />
        ))}
      </div>
    </div>
  );
};
